import heroIMG from '../../assets/images/projects/paka/hero.png';
import challengeIMG from '../../assets/images/projects/paka/challenge.png';
import structureIMG from '../../assets/images/projects/paka/structure.png';

import { projectAuthorData } from './projectAuthorData';

export const pakaProject = {
    id: 2,
    slug: 'paka',

    label: 'Shopify',
    category: 'Shopify Entwicklung',

    title: 'Paka',

    cardDescription:
        'Shopify-Projekt für eine Sportswear-Marke: Collection-Struktur, Produktseiten, mobile Darstellung und technische Shopify-Umsetzung für einen klareren Online-Shop.',

    image: heroIMG,
    imageAlt: 'Paka Shopify Store Startseite',

    tags: ['UX/UI', 'Entwicklung', 'Shopify'],

    website: 'https://paka.ua/',

    page: {
        seo: {
            title: 'PAKA — Shopify-Umsetzung für einen Sportswear Online-Shop | Nexon Digital Studio',

            description:
                'Shopify-Umsetzung für PAKA mit Sportswear-Collections, unterschiedlichen Zielgruppen, mobilen Anpassungen und einer flexiblen Store-Struktur.',
        },

        hero: {
            subtitle:
                'Nexon Digital Studio entwickelt und verbessert Shopify-Shops für kleine Unternehmen, Marken und Online-Händler in Deutschland — klar strukturiert, technisch sauber und auf Online-Verkauf ausgerichtet.',

            title: ['SHOPIFY', 'ENTWICKLUNG'],

            text: 'Shopify-Erstellung, Theme-Anpassung, Relaunch und technische Umsetzung für Unternehmen, die online verkaufen möchten.',

            button: 'Anfrage senden',
        },

        intro: {
            title: 'PAKA — Shopify-Umsetzung für einen Sportswear Online-Shop',

            texts: [
                'Für PAKA wurde ein Shopify-Store für Sportswear, Tennis- und Padel-Bekleidung technisch umgesetzt und strukturiert aufgebaut. Der Fokus lag auf klaren Produktkategorien, übersichtlichen Collections, mobiler Darstellung und einer sauberen technischen Grundlage für den Online-Verkauf.',

                'Das Projekt zeigt, wie Nexon Digital Studio Shopify-Shops mit mehreren Zielgruppen, Produktkategorien und Collection-Bereichen technisch unterstützt, verständlicher strukturiert und für Kunden besser nutzbar macht.',
            ],

            meta: [
                {
                    id: 1,
                    title: 'Shopify Store',
                    label: 'Projektart',
                },
                {
                    id: 2,
                    title: 'Sportswear',
                    label: 'Branche',
                },
                {
                    id: 3,
                    title: 'Collections',
                    label: 'Umfang',
                },
                {
                    id: 4,
                    title: 'Mobile Darstellung',
                    label: 'Fokus',
                },
            ],

            image: heroIMG,
            imageAlt: 'Paka Shopify Store Startseite',
        },

        challenge: {
            theme: 'dark',

            eyebrow: 'Ausgangssituation',

            title: 'Ein Shopify-Store mit mehreren Zielgruppen und Produktbereichen.',

            text: 'PAKA verkauft Sportswear für Racket Sports mit unterschiedlichen Bereichen für Männer, Frauen, Kinder und Accessoires. Der Shopify-Store musste mehrere Zielgruppen, Produktkategorien und Collections verständlich abbilden, damit Kunden schneller passende Kleidung und Produkte finden können.',

            items: [
                {
                    id: 1,
                    text: 'Mehrere Zielgruppen wie Man, Woman und Kinder mussten klar strukturiert werden',
                },
                {
                    id: 2,
                    text: 'Produktbereiche und Collections sollten übersichtlich auffindbar sein',
                },
                {
                    id: 3,
                    text: 'Sale-Produkte, neue Kollektionen und Accessoires mussten verständlich präsentiert werden',
                },
                {
                    id: 4,
                    text: 'Mobile Darstellung und Nutzerführung sollten auch bei vielen Produkten sauber funktionieren',
                },
                {
                    id: 5,
                    text: 'Startseite und Collection-Bereiche mussten auf Orientierung und Online-Verkauf ausgerichtet werden',
                },
                {
                    id: 6,
                    text: 'Der Store brauchte eine technische Grundlage für weitere Produkte, Kollektionen und Aktionen',
                },
            ],

            image: challengeIMG,
            imageAlt: 'Paka Produktbereich Shopify',
        },

        structure: {
            theme: 'light',

            eyebrow: 'Zielsetzung',

            title: 'Eine klare Shopify-Struktur für Sportswear und Racket-Sports schaffen.',

            text: 'Ziel des Projekts war es, den PAKA Shopify-Store klarer, nutzbarer und technisch sauber aufzubauen. Besonders wichtig waren eine verständliche Collection-Struktur, mobile Darstellung, klare Produktbereiche und eine technische Grundlage, die weitere Kollektionen und Aktionen unterstützt.',

            image: structureIMG,
            imageAlt: 'Paka Mobile Shopify Store',

            items: [
                {
                    id: 1,
                    title: 'Zielgruppen-Struktur',
                    text: 'Bereiche für Männer, Frauen, Kinder und Accessoires sollten klar organisiert werden, damit Kunden schneller passende Produkte finden.',
                },
                {
                    id: 2,
                    title: 'Collection-Aufbau',
                    text: 'Sale, neue Kollektionen und Produktbereiche wurden auf bessere Orientierung und einfachere Nutzerführung ausgerichtet.',
                },
                {
                    id: 3,
                    title: 'Mobile Darstellung',
                    text: 'Der Shopify-Store sollte auch auf Smartphones klar funktionieren und Produktbereiche übersichtlich darstellen.',
                },
                {
                    id: 4,
                    title: 'Technische Grundlage',
                    text: 'Shopify-Anpassungen wurden so umgesetzt, dass Produkte, Collections und Aktionen langfristig gepflegt und erweitert werden können.',
                },
            ],
        },

        shopifyImplementation: {
            theme: 'dark',

            eyebrow: 'Warum Nexon Digital Studio',

            title: 'Fokussierte Shopify-Umsetzung für produktstarke Sportswear-Stores.',

            text: 'Für PAKA lag der Fokus auf einer Shopify-Umsetzung, die mehrere Zielgruppen, Collections und Produktbereiche übersichtlich abbildet. Nexon Digital Studio unterstützte bei Store-Struktur, Produktpräsentation, mobiler Darstellung und technischen Anpassungen für den Online-Verkauf.',

            items: [
                {
                    id: 1,
                    title: 'Shopify-Expertise',
                    text: 'Technische Umsetzung von Shopify-Stores, Produktseiten, Collections und Theme-Anpassungen.',
                },
                {
                    id: 2,
                    title: 'Klare Produktstruktur',
                    text: 'Strukturierung von Zielgruppen, Produktbereichen und Collections für eine bessere Nutzerführung.',
                },
                {
                    id: 3,
                    title: 'Saubere Store-Umsetzung',
                    text: 'Technische Anpassungen am Shopify-Store, damit Produkte, Inhalte und Verkaufsbereiche langfristig pflegbar bleiben.',
                },
            ],
        },

        implementation: {
            theme: 'light',

            eyebrow: 'Umsetzung',

            title: 'Collections, Produktbereiche und mobile Darstellung technisch umgesetzt.',

            items: [
                {
                    id: 1,
                    eyebrow: 'Shopify Store',
                    title: 'Startseite und Collection-Bereiche',
                    text: 'Zentrale Bereiche des Shopify-Stores wurden technisch umgesetzt und klar auf Produktpräsentation, Orientierung und Online-Verkauf ausgerichtet.',
                },
                {
                    id: 2,
                    eyebrow: 'Zielgruppen & Produkte',
                    title: 'Übersichtliche Sportswear-Struktur',
                    text: 'Produktbereiche und Collections wurden so strukturiert, dass Kunden schneller passende Sportswear, Kategorien und Aktionen finden.',
                },
                {
                    id: 3,
                    eyebrow: 'Mobile Optimierung',
                    title: 'Nutzbar auf allen Geräten',
                    text: 'Mobile Darstellung, Navigation und Nutzerführung wurden geprüft und angepasst, damit der Shopify-Store auch auf Smartphones verständlich nutzbar bleibt.',
                },
            ],
        },

        results: {
            theme: 'light',

            eyebrow: 'Ergebnisse',

            title: 'Ein klar strukturierter Shopify-Store für Sportswear und Racket-Sports',

            stats: [
                {
                    id: 1,
                    value: '10+',
                    label: 'Store-Bereiche',
                    text: 'Strukturiert und technisch umgesetzt',
                },
                {
                    id: 2,
                    value: '4',
                    label: 'Zielgruppen',
                    text: 'Man, Woman, Boy und For Girl',
                },
                {
                    id: 3,
                    value: '3',
                    label: 'Breakpoints',
                    text: 'Desktop, Tablet und Mobile geprüft',
                },
                {
                    id: 4,
                    value: '100%',
                    label: 'Shopify',
                    text: 'Collection-Struktur, Produktpräsentation und technische Umsetzung',
                },
            ],

            testimonial: {
                quote: 'Bei diesem Projekt lag der Fokus darauf, einen Shopify-Store mit mehreren Zielgruppen und Produktbereichen verständlicher zu strukturieren. Besonders wichtig waren klare Collections, mobile Nutzerführung und eine technische Grundlage, die weitere Kollektionen, Aktionen und Produkte sauber unterstützt.',

                labelTitle: 'Kommentar-Label:',
                label: 'Kommentar zur Umsetzung',

                author: {
                    ...projectAuthorData,
                    name: 'Dmytro Kiriachek',
                    position: 'CEO Nexon Digital Studio',
                },
            },
        },

        faq: {
            title: 'Häufige Fragen zu diesem Shopify-Projekt',

            items: [
                {
                    id: 1,
                    question: 'Was wurde bei PAKA umgesetzt?',

                    answer: 'Bei PAKA lag der Fokus auf technischer Shopify-Umsetzung, klarer Collection-Struktur, Produktbereichen, mobiler Darstellung und einer sauberen Store-Struktur für den Online-Verkauf.',
                },
                {
                    id: 2,
                    question: 'Für welche Unternehmen ist dieses Shopify-Projekt relevant?',

                    answer: 'Dieses Shopify-Projekt ist relevant für Sportswear-Marken, Online-Händler und Shops mit mehreren Zielgruppen, Produktkategorien oder saisonalen Kollektionen.',
                },
                {
                    id: 3,
                    question: 'Welche Shopify-Bereiche wurden berücksichtigt?',

                    answer: 'Im Projekt wurden zentrale Shopify-Bereiche wie Startseite, Produktseiten, Collections, Navigation, mobile Darstellung und technische Store-Struktur berücksichtigt.',
                },
                {
                    id: 4,
                    question: 'Warum ist eine klare Collection-Struktur in Shopify wichtig?',

                    answer: 'Eine klare Collection-Struktur hilft Kunden, passende Produkte schneller zu finden. Besonders bei mehreren Zielgruppen, Kategorien, Sale-Bereichen und neuen Kollektionen ist eine verständliche Shopify-Struktur wichtig für Nutzerführung und Online-Verkauf.',
                },
                {
                    id: 5,
                    question: 'Kann Nexon Digital Studio ähnliche Shopify-Stores umsetzen?',

                    answer: 'Ja. Nexon Digital Studio unterstützt kleine Unternehmen, Marken und Online-Händler bei Shopify-Umsetzung, Theme-Anpassung, Produktseiten, Collections, mobiler Optimierung und technischer Store-Struktur.',
                },
                {
                    id: 6,
                    question: 'Unterstützt Nexon Digital Studio auch bestehende Shopify-Stores?',

                    answer: 'Ja. Bestehende Shopify-Stores können technisch angepasst, neu strukturiert oder für mobile Nutzung, Produktpräsentation und bessere Pflege im Shopify-Admin verbessert werden.',
                },
            ],

            button: {
                text: 'Anfrage senden',
                href: '#contacts',
            },
        },
    },
};
